import React from "react";
import PageLayout from "../../PageLayout";
import SecondPage from "./SecondPage";
import FourthPage from "./FourthPage";
import VideoCareer from "./VideoCareer";

const videos = [
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/C2mzqmI-RjQ?si=xuvbYzK3vIjJUn_V"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/F4Z3QhND8T8?si=Ki7rfy5DpBgEeZD3"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/62tzoHyimdg?si=PhWs1Ncw6Sc2_DOC"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
  <iframe
    width="100%"
    height="100%"
    style={{ borderRadius: "10px" }}
    src="https://www.youtube.com/embed/WqxVBSMMi78?si=f0LG6g_OXT76Jvco"
    title="YouTube video player"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    referrerpolicy="strict-origin-when-cross-origin"
    allowfullscreen
  ></iframe>,
];

function SportsVideo() {
  return (
    <div>
      <PageLayout
        title="Let us give wings to your stories"
        description="We at IBEX FILMZ understand the evolving landscape of digital media and its impact on audiences worldwide. Leveraging cutting-edge technology and creative storytelling, we ensure that each video or film we produce not only meets but exceeds the expectations of our clients. Our team of experts specializes in bringing ideas to life, transforming visions into cinematic experiences that resonate with viewers, leaving a lasting impression. "
        videosrc="./video.mp4"
      />
      <SecondPage
        title="Action Sports Video Production"
        para="Welcome to the adrenaline-packed world of action sports video production! 
Join us on an exhilarating journey through jaw-dropping landscapes, heart-pounding action, and awe-inspiring feats captured by our talented team at IBEX FILMZ. From extreme sports to epic outdoor adventures, our videos showcase thrill-seekers, the daredevils, and the champions of the wild. Get ready to be inspired, amazed, and transported to the edge of your seat. 
 "
      />
      <VideoCareer videos={videos} />
      {/* <FourthPage /> */}
    </div>
  );
}

export default SportsVideo;
